import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "temp",
  "use": "temp-usage",
  "viewBox": "0 0 8.1 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.1 20\" id=\"temp\"><title>temp</title><path d=\"M6.4 12.8V2.4c0-1.3-1-2.4-2.3-2.4-1.3 0-2.4 1.1-2.4 2.4v10.5C.7 13.5 0 14.7 0 16c0 2.2 1.8 4 4 4s4-1.8 4-4c.1-1.3-.5-2.5-1.6-3.2zm-2.3 6.3C2.4 19.1 1 17.7.9 16c0-1.1.6-2 1.5-2.6l.2-.1v-11c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v10.9l.2.1c.9.6 1.4 1.5 1.4 2.6 0 1.8-1.4 3.2-3.1 3.2z\" /><path d=\"M4.5 14.6V5.9h-.9v8.6c-.6.2-1.1.8-1.1 1.5 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6-.1-.7-.5-1.3-1.2-1.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/temp.svg
// module id = 8bpX
// module chunks = 6